import { Keyboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SUITS } from "@/lib/deck";
import { cn } from "@/lib/utils";

export function KeyboardBar({ activeSuit, setActiveSuit }) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-6" data-testid="keyboard-bar">
      <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground">Deal Suit</span>
      <div className="flex items-center gap-1.5" role="group" aria-label="Active suit for keyboard dealing">
        {SUITS.map((suit) => (
          <button
            key={suit.id}
            type="button"
            data-testid={`active-suit-${suit.id}`}
            aria-pressed={activeSuit === suit.id}
            aria-label={`Set active suit to ${suit.label}`}
            onClick={() => setActiveSuit(suit.id)}
            className={cn(
              "w-9 h-9 border-2 border-foreground flex items-center justify-center text-lg transition-[transform,box-shadow] duration-75",
              activeSuit === suit.id
                ? "bg-foreground text-background shadow-none"
                : cn(
                    "bg-card hover:-translate-y-0.5 hover:shadow-brutal-sm",
                    suit.color === "red" ? "text-suit-red" : "text-suit-black"
                  )
            )}
          >
            <span aria-hidden="true">{suit.symbol}</span>
          </button>
        ))}
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="outline"
            data-testid="hotkeys-btn"
            className="border-2 border-foreground rounded-none font-mono font-bold bg-card gap-2"
          >
            <Keyboard className="w-4 h-4" /> Keys
          </Button>
        </PopoverTrigger>
        <PopoverContent className="border-2 border-foreground rounded-none bg-popover w-72" data-testid="hotkeys-popover">
          <div className="space-y-2 font-mono text-xs">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Keyboard Shortcuts</p>
            <div className="flex justify-between gap-4"><span>Pick suit</span><span className="font-bold">S · H · D · C</span></div>
            <div className="flex justify-between gap-4"><span>Deal rank</span><span className="font-bold">A · 2-9 · 0=10 · J Q K</span></div>
            <div className="flex justify-between gap-4"><span>Undo</span><span className="font-bold">U</span></div>
            <p className="text-muted-foreground pt-1">Cards deal from the highlighted suit.</p>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
